//Reset data
export const RESET = "IA_RAPPORT_RESET"

//Loading
export const SET_TOGGLE_LOADING = "IA_RAPPORT_SET_TOGGLE_LOADING"
export const SET_SHOW_LOADING = "IA_RAPPORT_SET_SHOW_LOADING"
export const SET_HIDE_LOADING = "IA_RAPPORT_SET_HIDE_LOADING"

//Message
export const SET_MESSAGE = "IA_RAPPORT_SET_MESSAGE"
export const SET_IS_SUCCESS = "IA_RAPPORT_SET_IS_SUCCESS"
export const SET_IS_ERROR = "IA_RAPPORT_SET_IS_ERROR"

export const SET_TOGGLE_MESSAGE = "IA_RAPPORT_SET_TOGGLE_MESSAGE"
export const SET_SHOW_MESSAGE = "IA_RAPPORT_SET_SHOW_MESSAGE"
export const SET_HIDE_MESSAGE = "IA_RAPPORT_SET_HIDE_MESSAGE"

//Data
export const SET_ITEMS = "IA_RAPPORT_SET_ITEMS"
export const SET_CURRENT_ITEM = "IA_RAPPORT_SET_CURRENT_ITEM"

//Modal
export const SET_TOGGLE_MODAL = "IA_RAPPORT_SET_TOOGLE_MODAL"
export const SET_SHOW_MODAL = "IA_RAPPORT_SET_SHOW_MODAL"
export const SET_HIDE_MODAL = "IA_RAPPORT_SET_HIDE_MODAL"


export const SET_MODAL = "IA_RAPPORT_SET_MODAL"
export const SET_MODAL_CONTENT = "IA_RAPPORT_SET_MODAL_CONTENT"
export const SET_MODAL_TITLE = "IA_RAPPORT_SET_MODAL_TITLE"
export const SET_MODAL_SUBTITLE = "IA_RAPPORT_SET_MODAL_SUBTITLE"
export const SET_MODAL_TYPE = "IA_RAPPORT_SET_MODAL_TYPE"